const deviceTypeList = [
  {
    value: "Computer (Generic)",
    config: "1",
    label: "fing_type1",
    img: "Computer_(Generic).png",
  },
  {
    value: "Laptop",
    config: "2",
    label: "fing_type2",
    img: "Laptop.png",
  },
  {
    value: "Desktop",
    config: "3",
    label: "fing_type3",
    img: "Desktop.png",
  },
  {
    value: "Entertainment (Generic)",
    config: "4",
    label: "fing_type4",
    img: "Entertainment_(Generic).png",
  },
  {
    value: "TV",
    config: "5",
    label: "fing_type5",
    img: "TV.png",
  },
  {
    value: "Media Streamer",
    config: "6",
    label: "fing_type6",
    img: "Media_Streamer.png",
  },
  {
    value: "Gaming",
    config: "7",
    label: "fing_type7",
    img: "Gaming.png",
  },
  {
    value: "Smart Speaker",
    config: "8",
    label: "fing_type8",
    img: "Smart_Speaker.png",
  },
  {
    value: "Home Office (Generic)",
    config: "9",
    label: "fing_type9",
    img: "Home_Office_(Generic).png",
  },
  {
    value: "Printer",
    config: "10",
    label: "fing_type10",
    img: "Printer.png",
  },
  {
    value: "IoT (Generic)",
    config: "11",
    label: "fing_type11",
    img: "IoT_(Generic).png",
  },
  {
    value: "Smart Plug",
    config: "12",
    label: "fing_type12",
    img: "Smart_Plug.png",
  },
  {
    value: "Fridge",
    config: "13",
    label: "fing_type13",
    img: "Fridge.png",
  },
  {
    value: "Light",
    config: "14",
    label: "fing_type14",
    img: "Light.png",
  },
  {
    value: "Thermostat",
    config: "15",
    label: "fing_type15",
    img: "Thermostat.png",
  },
  {
    value: "Frame",
    config: "16",
    label: "fing_type16",
    img: "Frame.png",
  },
  {
    value: "Smart Phone (Generic)",
    config: "17",
    label: "fing_type17",
    img: "Smart_Phone_(Generic).png",
  },
  {
    value: "Tablet",
    config: "18",
    label: "fing_type18",
    img: "Tablet.png",
  },
  {
    value: "Network (Generic)",
    config: "19",
    label: "fing_type19",
    img: "Network_(Generic).png",
  },
  {
    value: "NAS",
    config: "20",
    label: "fing_type20",
    img: "NAS.png",
  },
  {
    value: "Router",
    config: "21",
    label: "fing_type21",
    img: "Router.png",
  },
  {
    value: "Extender",
    config: "22",
    label: "fing_type22",
    img: "Extender.png",
  },
  {
    value: "IP Phone",
    config: "23",
    label: "fing_type23",
    img: "IP_Phone.png",
  },
  {
    value: "Security (Generic)",
    config: "24",
    label: "fing_type24",
    img: "Security_(Generic).png",
  },
  {
    value: "Camera",
    config: "25",
    label: "fing_type25",
    img: "Camera.png",
  },
  {
    value: "Doorbell",
    config: "26",
    label: "fing_type26",
    img: "Doorbell.png",
  },
  {
    value: "Smart Lock",
    config: "27",
    label: "fing_type27",
    img: "Smart_Lock.png",
  },
  {
    value: "Wearable (Generic)",
    config: "28",
    label: "fing_type28",
    img: "Wearable_(Generic).png",
  },
];

const connTypeList = [
  {
    value: "",
    config: "main_2g",
    label: "2.4G",
    img: "24GConnection.png",
  },
  {
    value: "",
    config: "main_5g",
    label: "5G",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "guest_2g",
    label: "2.4G Guest",
    img: "24GConnection.png",
  },
  {
    value: "",
    config: "guest_5g",
    label: "5G Guest",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "wired",
    label: "",
    img: "wiredConnection.png",
  },
  {
    value: "",
    config: "wireless1_2g",
    label: "2.4G Wireless1",
    img: "24GConnection.png",
  },
  {
    value: "",
    config: "wireless1_5g",
    label: "5G Wireless1",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "wireless1_5g2",
    label: "5G High Wireless1",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "guest_portal_2g",
    label: "2.4G Guest Portal",
    img: "24GConnection.png",
  },
  {
    value: "",
    config: "guest_portal_5g",
    label: "5G Guest Portal",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "guest_portal_5g2",
    label: "5G High Guest Portal",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "wireless2_2g",
    label: "2.4G Wireless2",
    img: "24GConnection.png",
  },
  {
    value: "",
    config: "wireless2_5g",
    label: "5G Wireless2",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "wireless2_5g2",
    label: "5G High Wireless2",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "wireless3_2g",
    label: "2.4G Wireless3",
    img: "24GConnection.png",
  },
  {
    value: "",
    config: "wireless3_5g",
    label: "5G Wireless3",
    img: "5Gconnection.png",
  },
  {
    value: "",
    config: "wireless3_5g2",
    label: "5G High Wireless3",
    img: "5Gconnection.png",
  },
];

export const attached = {
  device_icon_type: deviceTypeList,
  conn_type: connTypeList,
};

export default attached;
